// @ts-nocheck
import { FormulaHelpers as H, Types, FormulaError } from 'fast-formula-parser';

export const Concatenate = (...params: any) => {
  let text = '';
  if (params.length === 0)
    throw Error('CONCATENATE need at least one argument.');
  params.forEach((param) => {
    // does not allow range reference, array, union

    if (param?.isRangeRef) {
      try {
        param = H.accept(param, Types.ARRAY, undefined, true);
      } catch (e) {
        // catch #VALUE! and throw #N/A
        if (e instanceof FormulaError) throw FormulaError.NA;
        throw e;
      }
    } else if (param?.isCellRef || param?.value) {
      param = [H.accept(param)];
    } else {
      throw FormulaError.REF;
    }

    param.forEach((value) => {
      if (value) text += `${value},`;
    });
  });

  if (text.charAt(text.length - 1) === ',')
    text = text.substring(0, text.length - 1);
  return text;
};
